module.exports = __webpack_public_path__ + "static/media/Abraham Lincoln.072bb097.jpg";